import { TOP_GAINERS_LOSERS, TOP_GAINERS_LOSERS_STREAM, TOP_GAINERS_LOSER_LAST_TIME_UPDATED, } from "../../../interface/DrivingMarket/iTopGainersLosers";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    latestUpdatedTime: "",
    data: [],
};
const topGainersLosersReducer = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case TOP_GAINERS_LOSERS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case TOP_GAINERS_LOSERS_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStream(state.data, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case TOP_GAINERS_LOSER_LAST_TIME_UPDATED:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default topGainersLosersReducer;
